import React, { useState, useEffect } from "react";
import {
  Typography,
  Stack,
  Box,
  Divider,
  Button,
  TextField,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Avatar,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import moment from "moment";
import { useQuery } from "@apollo/client";

// icon
import CheckIcon from "@mui/icons-material/Check";
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';

// src
import "../../Style/pageStyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
import EmptyData from "../../Components/Include/EmptyData";
import LoadingPage from "../../Components/Include/LoadingPage";
import SelectDatePicker from "../Include/SelecteDatePicker/SelectDatePicker";
import { GET_ALL_STUDENT_ATTENDANCE_BY_CLASS } from "../../Schema/Attendance";
import DeleteAttendanceByDay from "./DeleteAttendanceByDay"

import ViewAttendancePageAction from "./ViewAttendancePageAction"

export default function ViewAttendacePage({ classId }) {
  // Change Language
  const { language } = React.useContext(AuthContext);
  const { t } = translateLauguage(language);

  const userLogin = JSON.parse(window.localStorage.getItem("logIn"))

  const [dateVal, setDateVal] = useState(moment());
  const [loading, setLoading] = useState(true);


  const [open, setOpen] = useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  var daysInMonth = [];
  var monthDate = moment(dateVal)?.startOf("month");

  for (let i = 0; i < monthDate.daysInMonth(); i++) {
    let newDay = monthDate.clone().add(i, "days");
    let dayWithSuffix = newDay;
    daysInMonth.push(dayWithSuffix);
  }
  // const monthValue = moment.months();

  // const [fromDate, setFromDate] = useState(moment());
  // const [toDate, setToDate] = useState(moment());

  const [tableData, setTableData] = useState([]);
  const { refetch } = useQuery(GET_ALL_STUDENT_ATTENDANCE_BY_CLASS, {
    variables: {
      classId: classId,
      from: moment(dateVal).startOf("month").format("YYYY-MM-DD"),
      to: moment(dateVal).endOf("month").format("YYYY-MM-DD"),
    },
    onCompleted: ({ getAllStudentAttendanceByClass }) => {
      setTableData(getAllStudentAttendanceByClass);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, [dateVal]);

  // ======================= Resize width Screen ======================
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth - 50);
  };
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  return (
    <div>
      <Box sx={{ marginTop: "30px" }}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3, xl: 2 }}>
            <Typography
              className={language === "kh" ? "header-text-kh" : "header-text"}
            >
              {t(`date`)}
            </Typography>

            <SelectDatePicker
              inputFormat="yyyy-MMMM"
              format="yyyy-MMMM"
              views={["month", "year"]}
              date={dateVal}
              setDate={(e) => setDateVal(e)}
            />

          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 8, lg: 9, xl: 10 }}>
            <Stack direction="row" justifyContent="right">
              {
                (userLogin?.role === "Admin") || ((userLogin?.role !== "Admin") && `${moment().format("YYYY-MM")}` === `${moment(dateVal).format("YYYY-MM")}`) ? (
                  <Button
                    onClick={handleOpen}
                    className="btn-delte-style"
                    startIcon={
                      <DeleteSweepIcon className="icon-add" />
                    }
                  >
                    <Typography
                      className={language === "kh" ? "btn-txt-kh" : "btn-txt"}
                    >
                      {t("btn-delete")}
                    </Typography>
                  </Button>
                ) : ""
              }

            </Stack>
            <DeleteAttendanceByDay
              open={open}
              handleClose={handleClose}
              setRefetch={refetch}
              classId={classId}
            />
          </Grid>
        </Grid>
      </Box>
      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px`, whiteSpace: "nowrap" }}>
          <Table className="table" aria-label="simple table">
            <TableHead className="header-row ">
              <TableRow>
                <TableCell
                  className={
                    language === "en"
                      ? "header-title-start"
                      : "header-title-start-kh"
                  }
                >
                  {t("thead_no")}
                </TableCell>
                <TableCell
                  className={
                    language === "en" ? "header-title" : "header-title-kh"
                  }
                >
                  {t("thead_student_id")}
                </TableCell>
                <TableCell
                  className={
                    language === "en" ? "header-title" : "header-title-kh"
                  }
                >
                  {t("thead_student_name")}
                </TableCell>

                {daysInMonth?.map((day, index) => {
                  return (
                    <TableCell
                      key={index}
                      className={
                        language === "en" ? "header-title" : "header-title-kh"
                      }
                    >
                      {moment(day)?.format("DD")}
                    </TableCell>
                  );
                })}

                <TableCell
                  className={
                    language === "en" ? "header-title" : "header-title-kh"
                  }
                  align="center"
                >
                  {t("presence")}
                </TableCell>
                <TableCell
                  className={
                    language === "en" ? "header-title" : "header-title-kh"
                  }
                  align="center"
                >
                  {t("percentage")}
                </TableCell>

                <TableCell
                  className={
                    language === "en"
                      ? "header-title-end"
                      : "header-title-end-kh"
                  }
                  align="right"
                >

                </TableCell>
              </TableRow>
            </TableHead>
            {loading ? (
              <TableBody className="table-body">
                <TableRow className="body-row">
                  <TableCell colSpan={40} className="body-cell">
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0 ? (
                  <TableBody className="table-body">
                    <TableRow className="body-row">
                      <TableCell colSpan={40} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <>
                    <TableBody className="table-body">
                      {tableData?.map((row, index) => {
                        // console.log("row::", row)
                        return (
                          <TableRow className="body-row" key={index}>
                            <TableCell
                              className={
                                language === "en"
                                  ? "body-cell-start"
                                  : "body-cell-start-kh"
                              }
                            >
                              {index + 1}
                            </TableCell>
                            <TableCell
                              className={
                                language === "en" ? "body-cell" : "body-cell-kh"
                              }
                            >
                              {String(row?.student?.student_id ?? "").padStart(4, "0")}
                              {/* {row?.student?.student_id} */}
                            </TableCell>
                            <TableCell
                              className={
                                language === "en" ? "body-cell" : "body-cell-kh"
                              }
                            >
                              {language === "en"
                                ? row?.student?.full_name_latin
                                : row?.student?.full_name_kh}
                            </TableCell>
                            {row?.days?.map((day, index) => {
                              return (
                                <TableCell
                                  key={index}
                                  className={
                                    language === "en"
                                      ? "body-cell"
                                      : "body-cell-kh"
                                  }
                                >
                                  {day?.attendance_status === "Presence" ? (
                                    <CheckIcon
                                      style={{
                                        width: "22px",
                                        height: "auto",
                                        color: "#158843",
                                      }}
                                    />
                                  ) : (
                                    ""
                                  )}
                                </TableCell>
                              );
                            })}
                            <TableCell
                              className={
                                language === "en" ? "body-cell" : "body-cell-kh"
                              }
                              align="center"
                            >
                              {row?.totalPresence}
                            </TableCell>
                            <TableCell
                              className={
                                language === "en" ? "body-cell" : "body-cell-kh"
                              }
                              align="center"
                            >
                              {row?.totalPercentage} %
                            </TableCell>

                            <TableCell
                              className={
                                language === "en"
                                  ? "body-cell-end"
                                  : "body-cell-end-kh"
                              }
                              align="center"
                            >
                              <ViewAttendancePageAction dataStuAttended={row?.class_attended_id} setRefetch={refetch} enrollmentTypeAction="view_att_page" />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </>
                )}
              </>
            )}
          </Table>
        </TableContainer>
      </Box>
    </div>
  );
}
